import { NavLink } from "react-router-dom";

export default function UserSidebar({ iconColor, isActive }) {
  return (
    <div
      className={`tab-pane fade ${isActive ? "show active" : ""}`}
      id="tab_user_portal"
      role="tabpanel"
    >
      <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
        {/* DASHBOARD */}
        <li>
          <NavLink to="/user/dashboard" aria-label="Dashboard">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <path d="M3 12L12 3l9 9" />
              <path d="M5 10v10h14V10" />
              <path d="M10 14h4v6h-4z" />
            </svg>
            <span className="mx-3">Dashboard</span>
          </NavLink>
        </li>

        {/* PROFILE */}
        <li>
          <NavLink to="/user/profile" aria-label="My Profile">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <circle cx="12" cy="7" r="4" />
              <path d="M5.5 21v-2a6.5 6.5 0 0 1 13 0v2" />
            </svg>
            <span className="mx-3">My Profile</span>
          </NavLink>
        </li>

        {/* ATTENDANCE */}
        <li>
          <NavLink to="/user/attendance" aria-label="Attendance">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <path d="M3 5h18" />
              <path d="M3 9h12" />
              <path d="M3 13h9" />
              <path d="M3 17h6" />
            </svg>
            <span className="mx-3">Attendance</span>
          </NavLink>
        </li>

        {/* PUNCH LOGS */}
        <li>
          <NavLink to="/user/punches" aria-label="Punch Logs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span className="mx-3">Punch Logs</span>
          </NavLink>
        </li>

        {/* APPLY LEAVE */}
        <li>
          <NavLink to="/user/leave/apply" aria-label="Apply Leave">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <path d="M4 4h16" />
              <path d="M4 8h10" />
              <path d="M4 12h6" />
              <path d="M17 14l3 3" />
              <path d="M17 17l3 -3" />
            </svg>
            <span className="mx-3">Apply Leave</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/user/punch-in" aria-label="PunchIn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <path d="M3 12L12 3l9 9" />
              <path d="M5 10v10h14V10" />
              <path d="M10 14h4v6h-4z" />
            </svg>
            <span className="mx-3">Punch IN</span>
          </NavLink>
        </li>

        {/* LEAVE HISTORY */}
        {/* <li>
          <NavLink to="/user/leave/history" aria-label="Leave History">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-stroke"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 8v4l3 2" />
            </svg>
            <span className="mx-3">Leave History</span>
          </NavLink>
        </li> */}
      </ul>
    </div>
  );
}
